
import { Component, Vue, Watch } from "vue-property-decorator";

import ForgetPassword from "./ForgetPassword.vue";
import { Getter } from "vuex-class";
import axios from "@/network/api";
import { AxiosError, AxiosResponse } from "axios";
import { AppEventState } from "@/models/AppEventState";
import publicApi from "@/network/public_api";

@Component({
  components: {
    ForgetPassword
  },
  mounted() {
    if (localStorage.getItem("access_token") !== null) {
      this.$router.push("/"); // go to homepage if a token already exists
    }
  }
})
export default class LoginPage extends Vue {
  private email = "";
  private password = "";
  private showTerms = false;
  private showForgetPassword = false;
  private acceptedTerms = false;
  private validEventCode = false;
  private eventCode = "";
  @Getter("errorMsg") private errorMsg!: string;
  @Getter("errorCode") private errorCode!: number;

  beforeCreate() {
    if (this.$route.query && this.$route.query.code) {
      this.eventCode = `${this.$route.query.code}`;
      publicApi
        .get("/event_by_code?code=" + this.eventCode)
        .then(res => {
          this.validEventCode = true;
        })
        .catch((error: AxiosError) => {
          // the code is either not valid, or the feature is disabled
          // just hide the Register button
          this.validEventCode = false;
        });
    }
  }

  @Watch("email")
  validateCredential(val: string) {
    if (val.includes("@")) {
      document.getElementById("inputEmail")?.setAttribute("type", "email");
    } else {
      document.getElementById("inputEmail")?.setAttribute("type", "text");
    }
  }

  onSubmit() {
    this.$store.dispatch("login", {
      email: this.email,
      password: this.password,
      acceptedTerms: true, // add always true only for sec version
      eventCode: this.$route.query.code,
      to: this.$route.params.redirectTo ? this.$route.params.redirectTo : "/"
    });
  }
}
